import { render, staticRenderFns } from "./BaseTableColumn.vue?vue&type=template&id=76f6ab1a"
import script from "./BaseTableColumn.vue?vue&type=script&lang=js"
export * from "./BaseTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports